import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {optionsToArray} from "@app/utils/CommonUtils";
import {callApiSearchSavedList} from "@pages/savedlist/common/Services";
import MailTemplateList from "@pages/email/template/list/MailTemplateList";
import {MailTempType} from "@pages/email/common/Constant";
import {AcquireCddTabs, ConnectCddEmpTabs, DVTJCUVTabs} from "@pages/email/template/dvtjcuv/DVTJCUVTemplateListManager";

const DVTJCUVChildrenTabManager = (props) => {
    const [pTabId, setPTabId] = useState(DVTJCUVTabs.ACQUIRE_CDD_TAB.id);
    const [currentTabId, setCurrentTabId] = useState(AcquireCddTabs.INVITE_TAB.id);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [tabTotals, setTabTotals] = useState({});
    const [tabs, setTabs] = useState({});

    const {parentTabId, tabList} = props

    useEffect(async () => {
        setPTabId(parentTabId);
        setTabs({...tabList})
        let firstTab = tabList[Object.keys(tabList)[0]];
        setCurrentTabId(firstTab.id)
    }, [parentTabId, tabList])

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    const onTabClicked = (tabId) => {
        setCurrentTabId(tabId);
    };

    const activeTab = (tabId) => {
        if (currentTabId === tabId) {
            return 'active'
        }
        return ''
    }

    const getTabTitle = (tab) => {
        const total = tabTotals[tab.id] ? tabTotals[tab.id] : 0
        return `${tab.title} (${total})`
    }


    return (
        <>
            <div className='card card-default'>
                <div className='card-body p-0'>
                    <ul className='nav nav-tabs' role='tablist'>
                        {Object.keys(tabs).map(key => {
                            let tab = tabs[key];
                            return <li className={`nav-item ${activeTab(tab.id)}`} key={`${tab.id}_tab`}>
                                <a className={`nav-link text-bold ${activeTab(tab.id)}`} data-toggle='tab' href={"#" + tab.id}
                                   onClick={() => {onTabClicked(tab.id)}}>{getTabTitle(tab)}</a>
                            </li>
                        })}
                    </ul>
                    <div className='tab-content'>
                        {Object.keys(tabs).map(key => {
                            let tab = tabs[key];
                            if (tab.id === currentTabId) {
                                return <div key={`${tab.id}_content`}
                                            className={`tab-pane ${activeTab(tab.id)}`}
                                            style={{height: '83vh', overflow: 'auto'}}>
                                    <MailTemplateList templateType={tab.templateType || MailTempType.DVTJCUV_INVITE_EMAIL} tabId={currentTabId}
                                                      parentTabId={pTabId}/>
                                </div>
                            }
                            return "";
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DVTJCUVChildrenTabManager;
